import React from 'react';

import { getLocalDate } from 'common/utils';

import { Grid, Typography } from 'e100-react-components';
import { Icon } from 'components';
import { CopyIconButton } from '../CopyIconButton/CopyIconButton';

import { useStyles } from './styles';
import { useIntl } from 'react-intl';
import { TransactionWithType, useGetHistoryEventTitle } from 'entities/navigation';

export const ClientTransactionEvent = ({ historyEvent }: ClientTransactionEventProps) => {
  const classes = useStyles();
  const { formatMessage } = useIntl();
  const getHistoryEventTitle = useGetHistoryEventTitle();

  const {
    latitude,
    longitude,
    date,
    type,
    cardNumber,
    clientAmount,
    clientCurrency,
    clientPrice,
    stationUid,
    volume,
    serviceTitle,
  } = historyEvent;

  return (
    <Grid container spacing={0} alignItems="center" justify="space-between">
      <Grid item xs={12}>
        <div className={classes.textContainer}>
          <span className={classes.iconContainer}>
            <Icon kind={'localGasStationOutlined'} />
          </span>
          <Grid container spacing={0}>
            <Grid item xs={12}>
              <Typography variant="subtitle2" component="p" color="textPrimary" classes={{ root: classes.text }}>
                {getHistoryEventTitle(type)}
              </Typography>
            </Grid>
            <Grid item>
              <Grid container spacing={0} alignItems="center">
                <Grid item xs={12}>
                  <Grid container spacing={0}>
                    <Grid
                      item
                      classes={{
                        root: classes.item,
                      }}
                    >
                      <Typography variant="subtitle2" color="secondary" component="p" classes={{ root: classes.date }}>
                        {getLocalDate(date)}
                      </Typography>
                    </Grid>
                    <Grid item>
                      <CopyIconButton
                        title={formatMessage({ id: 'copyСoordinates' })}
                        message={`${latitude}, ${longitude}`}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  <Grid container>
                    <Grid item xs={10}>
                      <Typography variant="subtitle2" color="secondary" component="p" classes={{ root: classes.date }}>
                        {`${stationUid} • ${serviceTitle} • ${volume}l • ${clientAmount} ${clientCurrency} • ${clientPrice} ${clientCurrency}/l • Card ${cardNumber}`}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </div>
      </Grid>
      <Grid item xs={12}>
        <br />
      </Grid>
    </Grid>
  );
};

interface ClientTransactionEventProps {
  historyEvent: TransactionWithType;
}
